var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomInfo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4 15c0-5.744-4.656-10.4-10.4-10.4C9.256 4.6 4.6 9.256 4.6 15M2 15C2 7.82 7.82 2 15 2s13 5.82 13 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 15c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4m2.6 0c0 7.18-5.82 13-13 13S2 22.18 2 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.63 22.147h-1.25a1 1 0 0 1-1-1v-7.75a1 1 0 0 1 1-1h1.25a1 1 0 0 1 1 1v7.75a1 1 0 0 1-1 1zM13.38 9.702c0-.525.14-.93.424-1.213.283-.283.687-.425 1.213-.425.508 0 .904.142 1.188.425.283.283.424.688.424 1.213 0 .5-.141.893-.424 1.18-.284.288-.68.432-1.188.432-.526 0-.93-.144-1.213-.431-.283-.288-.425-.681-.425-1.181z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-info.4978a4feb80428bb6de08af53e32e261.svg";